import { IndustryPageTemplate } from "@/components/templates/IndustryPageTemplate";
import { aiAdsCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiAdsCluster.industryPages.find(p => p.slug === "paid-ads-b2b-software")!;
const relatedMoney = getRelatedMoneyPages("ai-ads").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-ads").map(p => ({ title: p.title, slug: p.slug }));

export default function PaidAdsB2BSoftwarePage() {
  return (
    <IndustryPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
